import { useFiltersContext } from './useFiltersContext';
import { FOfferType, offerTypeFromJsonQuery } from '../../../JsonQuery';

export function useOfferType(): FOfferType {
  const { jsonQuery } = useFiltersContext();

  return offerTypeFromJsonQuery(jsonQuery);
}
